import React from 'react';
import {NativeStackScreenProps} from '@react-navigation/native-stack';

import {StackParamList} from '../../../../navigators';
import {PrimaryButton, SecondaryButton} from '../../../../components/buttons';
import {message} from '../../../../utils/messages';
import {useSalesmanContext} from '../../../../context/salesman';
import {INewClientRequest} from '../../../../interfaces/dtos';
import {RejectedTemplate} from '../../../../components/templates/rejected';
import {IProofPaymentRequest} from '../../../../interfaces/dtos/proof-payment-request.interface';
import {IOrderRequest} from '../../../../interfaces/services/order-request.interface';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'WithoutConnectionConfirm'
>;

const WithoutConnectionConfirm = ({navigation, route}: ScreenProps) => {
  const {saveRequestToServer} = useSalesmanContext();

  const handlePrimaryPress = async () => {
    const request: INewClientRequest | IProofPaymentRequest | IOrderRequest =
      route.params.request;
    const {workflow} = route.params;
    const result = await saveRequestToServer(route.params.workflow, request);
    if (result && workflow) {
      navigation.navigate('WithoutConnectionSaveSucess', {workflow});
    }
  };
  const handleSecondaryPress = () => {
    navigation.goBack();
  };

  return (
    <RejectedTemplate
      title={message('without-connection-confirm-save-title')}
      summary={message('without-connection-confirm-save-summary')}>
      <PrimaryButton
        label={message('without-connection-confirm-save-primary-button')}
        onPress={() => handlePrimaryPress()}
      />
      <SecondaryButton
        label={message('without-connection-confirm-save-secondary-button')}
        mt="5"
        onPress={() => handleSecondaryPress()}
      />
    </RejectedTemplate>
  );
};

export default WithoutConnectionConfirm;
